<template>
  <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options"></AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";
import { environmentOptions } from "@/components/StorageEnvironment/labels";

export default {
  name: "SparePartForm",
  components: {
    AdminForm
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {
        storage_environment_id: null,
        supplier_id: null
      },
      isBusy: false
    };
  },
  computed: {
    options: function() {
      return {
        // Hors cascade : libellé hiérarchique « Entrepôt > Zone > Environnement ».
        storage_environment_id_options: environmentOptions(this.$store.getters["storage_environment/getAll"]),
        supplier_id_options: this.$store.getters["company/getByTypeCode"](
          "FRNI"
        ).selectOptions("id", "name")
      };
    }
  },
  mounted() {
    // Duplication
    // Chargement de la copie qui a été préparée s'il y en a une
    const copy = this.$store.getters[config.storeNamespace + "/getCopy"];
    if (this.$route.name == config.newRouteName && copy) {
      this.form = { ...copy };
      this.$store.commit("reference/emptyCopy");
    }

    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true
        })
        .then(() => {
          let item = _.cloneDeep(
            this.$store.getters[config.storeNamespace + "/getItem"](id)
          );
          this.form = {
            ...item,
            storage_environment_id: item.storage_environment
              ? item.storage_environment.id
              : null,
            supplier_id: item.supplier ? item.supplier.id : null
          };
          this.isBusy = false;
        });
    }

    this.$store.dispatch("storage_environment/getAllForSelect");
    this.$store.dispatch("company/getAllForSelect");
  }
};
</script>


// WEBPACK FOOTER //
// src/components/SparePart/SparePartForm.vue